import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { serviceRemindersListSearchSchema } from '&/features/service-reminders/lib/service-reminders-list-search';
import { SERVICE_REMINDERS_PATH, SERVICE_REMINDERS_VIEW_PERMISSION } from '&/features/service-reminders/paths';
import { requireModule } from '&/lib/module-gate';

export const Route = createFileRoute('/_authenticated/reminders')({
  beforeLoad: ({ context }): void => {
    // Entitlement: a tenant without the Maintenance module gets the standard not-found (SWOOP-276), never a
    // redirect or an upsell. Covers client-side navigation only; the page wraps itself in <ModuleGate> for
    // the hard-refresh case.
    requireModule(context.entitlement, SERVICE_REMINDERS_PATH);
    // Permission gate (separate concern, and a redirect rather than a not-found, as the vehicles list does).
    if (context.permissions.isReady && !context.permissions.hasPermission(SERVICE_REMINDERS_VIEW_PERMISSION)) {
      throw redirect({ to: '/' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/service-reminders/pages/service-reminders-page')),
  staticData: { titleKey: 'serviceReminders' },
  // The tab, search, filters and page live in the URL, so a reload or a shared link restores the view. Every
  // field is optional and coerced, so a hand-edited URL never rejects. The master selection is not in it.
  validateSearch: (search) => serviceRemindersListSearchSchema.parse(search),
});
